export var getWidthFromDragLocation = function getWidthFromDragLocation(_ref) {
  var initialWidth = _ref.initialWidth,
    location = _ref.location,
    direction = _ref.direction;
  var diffX = location.current.input.clientX - location.initial.input.clientX;
  return direction === 'rtl' ? initialWidth - diffX : initialWidth + diffX;
};

/**
 * Returns the computed width of an element in pixels.
 */
export var getComputedWidth = function getComputedWidth(element) {
  var _window$getComputedSt = window.getComputedStyle(element),
    width = _window$getComputedSt.width;
  return parseInt(width);
};